// version v_2.2.1
// FIXED PASSWORD RESET REDIRECT ISSUE
// ✔ prevents logout on public routes
// ✔ keeps protected routes secure
// ✔ interceptor cleanup supported
// ✔ cookie-based auth preserved
// ✔ forgot-password flow fixed
// ✔ reset-password flow fixed

import axios from 'axios';

const API = axios.create({
  baseURL: 'https://apiclientportal.myidealtd.co.uk',
  // baseURL: 'http://localhost:8086',
  withCredentials: true,
});

// store interceptor id so we can clean it later
let interceptorId = null;

// =====================================================
// PUBLIC ROUTE CHECK
// =====================================================
const isPublicRoute = () => {
  const path = window.location.pathname;

  return (
    path === '/' ||
    path === '/login' ||
    path === '/register' ||
    path === '/forgot-password' ||
    path.startsWith('/reset-password/')
  );
};

// =====================================================
// AXIOS INTERCEPTOR (SAFE + CLEANUP SUPPORT)
// =====================================================
export const setupAxiosInterceptors = (onLogout) => {

  // remove old interceptor if exists
  if (interceptorId !== null) {
    API.interceptors.response.eject(interceptorId);
  }

  interceptorId = API.interceptors.response.use(
    (response) => response,

    (error) => {
      const status = error.response?.status;

      // Only logout on protected pages
      if (
        status === 401 &&
        !isPublicRoute()
      ) {
        onLogout();
      }

      return Promise.reject(error);
    }
  );

  return interceptorId;
};

export default API;